import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ContactAndPaymentForm, {
  ContactAndPaymentFormRef,
  ContactAndPaymentFormValues,
} from './ContactAndPaymentForm';
import { ICompany } from '@nxsys/types/models/company';

type EditContactAndPaymentModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: ContactAndPaymentFormValues) => Promise<void>;
  data: ICompany;
};

const EditContactAndPaymentModal: React.FC<EditContactAndPaymentModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ContactAndPaymentFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ContactAndPaymentFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editContactAndPayment']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <ContactAndPaymentForm
        companyData={data}
        formRef={formRef}
        onSubmit={handleSubmit}
      />
    </AppModalContainer>
  );
};

export default EditContactAndPaymentModal;
